import {getSport} from "../../api/features/sports";

const state = () => ({

  sport:{},
  newsId: null
})

const getters = {
  get_sport(state) {
    return state.sport;
  },
}

const mutations = {
  SET_SPORT(state,data){
    state.sport = data;}
}

const actions = {
  async fetchSport({ commit }) {
    try {
      const response = await getSport();
      commit('SET_SPORT', response.data.results);
    } catch (error) {
    }
  },

}




export  default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
